export const CHANGE_SCENARIO_NAME = "CHANGE_SCENARIO_NAME";
export const CHANGE_VALID = "CHANGE_VALID";
export const CHANGE_SUBMITTING = "CHANGE_SUBMITTING";
export const CHANGE_REQUESTING_NEXT = "CHANGE_REQUESTING_NEXT";
export const CHANGE_FETCHING = "CHANGE_FETCHING";
export const CHANGE_CALLING_NEXT_CALLBACK = "CHANGE_CALLING_NEXT_CALLBACK";

export const changeScenarioName = (name) => ({
  type: CHANGE_SCENARIO_NAME,
  payload: {
    scenarioName: name,
  },
});

export const changeValid = (valid) => ({
  type: CHANGE_VALID,
  payload: { valid },
});

export const changeSubmitting = (submitting) => ({
  type: CHANGE_SUBMITTING,
  payload: { submitting },
});

export const changeRequestingNext = (requestingNext) => ({
  type: CHANGE_REQUESTING_NEXT,
  payload: { requestingNext },
});

export const changeFetching = (fetching) => ({
  type: CHANGE_FETCHING,
  payload: { fetching },
});

export const changeCallingNextCallback = (calling) => ({
  type: CHANGE_CALLING_NEXT_CALLBACK,
  payload: { calling },
});
